import { PropsWithChildren } from 'react';

import { GTMProvider } from 'react-gtm-hook';

export type GTMContainerProps = {
  gtmId: string;
};

export const GTMContainer = ({
  gtmId,
  children,
}: PropsWithChildren<GTMContainerProps>) => (
  <GTMProvider data-testid="gtm-container" config={{ id: gtmId }}>
    {children}
  </GTMProvider>
);
